import Vue from 'vue';
import Element from 'element-ui';
import VueI18n from 'vue-i18n'
import kkLocale from 'element-ui/lib/locale/lang/kz';
import ruLocale from 'element-ui/lib/locale/lang/ru-RU';
import kk from './locale/kk';
import ru from './locale/ru';
const messages = {
    kk: {
        ...kk,
        ...kkLocale
    },
    ru: {
        ...ru,
        ...ruLocale
    }
};
let lang = localStorage.getItem('lang');
let locale = lang == 'kk-KZ' ? 'kk' : 'ru';

window.sessionStorage.setItem('lang', locale);// 设置缓存为默认语言
Vue.use(VueI18n);
const i18n = new VueI18n({
    locale: locale, // 设置默认语言
    messages,
    silentTranslationWarn: true
});

Vue.use(Element,{
    i18n: (key,value) => i18n.t(key,value)
});
export default i18n;



// WEBPACK FOOTER //
// ./src/i18n/i18n.js